export const userRole = {
  ADMIN: "admin",
  USER: "user",
};
